/**
 * "Jazz Piano First Steps" hand-off on the post-purchase welcome page.
 *
 * WordPress sent new members straight into Jazz Piano First Steps right after
 * the thank-you survey when they answered piano + beginner or piano +
 * intermediate (the "Survey redirect" rows in OS - Settings, live since
 * 2026-10-02). The welcome page keeps that flow: survey submitted → straight
 * into the course, nothing in between. Everyone else goes to their home
 * dashboard (lib/userHomeUrl.ts).
 *
 * This is deliberately limited to the moment right after purchase; the home
 * dashboard itself still resolves to the level course (Foundations /
 * Expansions), as agreed with Dan and Ben.
 */
import { normalizeInstrumentSlug, normalizeLevelKey } from '@/lib/dashboardHomeSurvey';

export const FIRST_STEPS_COURSE_SLUG = 'jazz-piano-first-steps';

export function firstStepsCourseHref(): string {
  return `/courses/${FIRST_STEPS_COURSE_SLUG}`;
}

/** Piano + beginner or piano + intermediate; survey answers required. */
export function surveyOpensFirstSteps(metadata: Record<string, unknown> | null | undefined): boolean {
  if (normalizeInstrumentSlug(metadata?.instrument) !== 'piano') return false;
  const level = normalizeLevelKey(metadata?.level);
  return level === 'beginner' || level === 'intermediate';
}
